import React from "react";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import { SelectedBitContStyled } from "./selectedBit.styles";

const SelectedBit = ({ bit, won_price }) => {
  console.log(bit);
  // debugger;

  if (!bit) return null;

  const { firstname, lastname, profile_img } = bit;

  return (
    <SelectedBitContStyled profile_img={profile_img}>
      <div className="selected-bit__title">
        <div className="selected-bit__img">
          {/* {profile_img ? <img src={profile_img} alt="" /> : null} */}
        </div>

        <div className="font-weight-bold font-size--2">
          {firstname} {lastname}
        </div>
      </div>

      <div className="selected-bit__price">
        <span>قیمت پیشنهادی: </span>
        <span>{toSeperatedNum(toPersianNum(won_price))} </span>
        <span>تومان</span>
      </div>
    </SelectedBitContStyled>
  );
};

export default SelectedBit;
